import { ChartFlipper } from '../chart-flipper'
import { SideBySideChart } from '../side-by-side-chart'
import { SplitChartFilterBar } from '../split-chart-filter-bar'
import { SideBySideChartContainer } from '../side-by-side-chart-container'
import { MapChart } from './map-chart'
import { useStyles } from './map-block-chart.style'

const DEFAULT_MAP_WIDTH = '100%'
const DEFAULT_MAP_HEIGHT = 500

export const MapBlockChart = function ({
  dataKey,
  chartData,
  tableData,
  region,
  valueRange,
  referenceData,
  showTable,
  showTableToggle,
  tableDefinition,
  filterDefinition,
  onSplitFilterChange,
  splitChart = false,
  exporting = false,
  width = DEFAULT_MAP_WIDTH,
  height = DEFAULT_MAP_HEIGHT,
  ...props
}) {
  const classes = useStyles()

  const tableProps = (tableDefinition || {}).props || {}
  if (splitChart) {
    tableProps.width = width - 32
  }

  return <>
    {splitChart && <SplitChartFilterBar
      filterDefinition={filterDefinition}
      onChange={onSplitFilterChange}
      className={classes.sideBySideChartFilterBar}
      displayOnly={exporting}/>}
    {splitChart ? (
      <SideBySideChartContainer className={classes.sideBySideChartContainer}>
        <div className={classes.sideBySideChart} style={!chartData || !chartData[0] ? { marginLeft: 0 } : null}>
          <SideBySideChart
            data={chartData && chartData[0] && Object.values(chartData[0]).length}
          >
            <ChartFlipper
              isHalf
              dataKey={dataKey}
              enabled={showTableToggle}
              showTable={showTable}
              tableData={tableData && tableData[0]}
              tableProps={tableProps}
              chartSideStyles={{ left: -15 }}
              tableSideStyles={{ left: 4 }}
            >
              <MapChart
                region={region}
                width={width}
                regionData={chartData && chartData[0]}
                valueRange={valueRange}
                referenceData={referenceData}
                mapKeyPosition={{
                  right: -85,
                  bottom: -64
                }}
                splitChart={splitChart}
                {...props}
              />
            </ChartFlipper>
          </SideBySideChart>
        </div>
        <div className={classes.sideBySideChart}>
          <SideBySideChart data={chartData && chartData[1] && Object.values(chartData[1]).length}>
            <ChartFlipper
              isHalf
              dataKey={dataKey}
              enabled={showTableToggle}
              showTable={showTable}
              tableData={tableData && tableData[1]}
              tableProps={tableProps}
              chartSideStyles={{ right: -15 }}
              tableSideStyles={{ right: -4 }}
            >
              <MapChart
                region={region}
                width={width}
                regionData={chartData && chartData[1]}
                valueRange={valueRange}
                referenceData={referenceData}
                showKey={false}
                splitChart={splitChart}
                {...props}
              />
            </ChartFlipper>
          </SideBySideChart>
        </div>
      </SideBySideChartContainer>
    ) : (
      <ChartFlipper
        dataKey={dataKey}
        enabled={showTableToggle}
        showTable={showTable}
        tableData={tableData && tableData[0]}
        tableProps={tableProps}
      >
        <MapChart
          region={region}
          width={width}
          height={height}
          regionData={chartData && chartData[0]}
          valueRange={valueRange}
          referenceData={referenceData}
          {...props}
        />
      </ChartFlipper>
    )}
  </>
}
